import { render } from "./Rentals.vue?vue&type=template&id=75446248"
import script from "./Rentals.vue?vue&type=script&lang=js"
export * from "./Rentals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__